(function() {
    'use strict';

    angular.module('format')
        .controller('FormatGroupDetailController', FormatGroupDetailController);

    FormatGroupDetailController.$inject = ['$state', 'notificationSrvc', 'formatGroupDataSrvc', 'formatGroupSrvc', 'formatDataSrvc', 'formatSrvc', 'formatMessagesConst', 'lodashService', 'datatableDefaultPageSizeValueConst', 'formatPermissionsConst', 'checkSearchSrvc', 'filterQuerySrvc'];

    function FormatGroupDetailController($state, notificationSrvc, formatGroupDataSrvc, formatGroupSrvc, formatDataSrvc, formatSrvc, formatMessagesConst, lodashService, datatableDefaultPageSizeValueConst, formatPermissionsConst, checkSearchSrvc, filterQuerySrvc) {
        var self = this;

        self.loading = true;

        self.groupName = null;

        self.pageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };

        self.formatRows = [];
        self.formatCols = [{
            title: 'ID',
            value: 'pk',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Rozmiar X',
            value: 'size_x',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Rozmiar Y',
            value: 'size_y',
            type: 'text',
            searchable: true,
            orderable: true
        }];

        self.modelPermissions = formatPermissionsConst;

        self.searchQuery = {
            pk: null,
            size_x: null,
            size_y: null,
            ordering: null
        };

        self.onCreate = onCreate;
        self.onEdit = onEdit;
        self.onDelete = onDelete;

        self.pageChange = pageChange;
        self.onSearchQueryChange = onSearchQueryChange;

        activate();

        function activate() {
            self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
            self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            getFormats();
            getGroupName($state.params.pk);
        }

        function getFormats(filterObj) {
            self.loading = true;

            if (!filterObj) {
                filterObj = {
                    group_pk: $state.params.pk,
                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,
                    pk: self.searchQuery.pk,
                    size_x: self.searchQuery.size_x,
                    size_y: self.searchQuery.size_y,
                    ordering: self.searchQuery.ordering
                };
            }
            return formatDataSrvc.formatsList(filterObj)
                .$promise
                .then(
                    function(response) {
                        self.formatRows = response.results;
                        self.pageOpts.count = response.count;
                        return response;
                    },
                    function(response) {
                        if (response.status === 404 && filterObj.page !== 1) {
                            checkSearchSrvc.recall(filterObj, getFormats);
                        }
                    }
                ).finally(
                    function(response) {
                        self.loading = false;
                        return response;
                    }
                );
        }

        function getGroupName(pk) {
            return formatGroupDataSrvc.get({
                pk: pk
            }).$promise.then(function(response) {
                self.groupName = response.name_pl;
                return response;
            });
        }

        function onCreate() {
            $state.go('layout.format.create', { groupPk: $state.params.pk });
        }

        function onEdit(row) {
            $state.go('layout.format.update', { pk: row.pk, groupPk: $state.params.pk });
        }

        function onDelete(row) {
            return formatSrvc.remove(row.size_x + "x" + row.size_y, row.pk, function(response) {
                notificationSrvc.notification("success", formatMessagesConst.delete);
                lodashService.remove(self.formatRows, { pk: row.pk });
                return response;
            });
        }

        function pageChange() {
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            filterQuerySrvc.setLocationParams();
            return getFormats();
        }

        function onSearchQueryChange() {
            filterQuerySrvc.updateSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            return getFormats();
        }
    }
})();
